import * as React from "react";
import { createRoot } from "react-dom/client";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fad } from "@fortawesome/pro-duotone-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

import "react-loading-skeleton/dist/skeleton.css";

import App from "./App";

library.add(fad);
library.add(fab);

const container = document.getElementById("app");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(<App />);

// ReactDOM.render(<App />, document.getElementById("app"));

declare global {
    interface Window {
        identityServer: string;
        discordServer: string;
    }
}
